export enum IdefendWarningCode {
  ANNUAL_LIMIT_EXCEEDED = 'premium_exceeds_legal_annual_limit',
}
